import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IValidatePromoCodeRequest, IValidatePromoCodeResponse } from './promoCodeTypes';

export const validatePromoCode = async (
  payload: IValidatePromoCodeRequest,
): Promise<IValidatePromoCodeResponse> => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.post<IValidatePromoCodeResponse>(
    '/payment/user/promo-code/validate',
    payload,
    { headers },
  );
  return response.data;
};

export const promoCodeApi = {
  validatePromoCode,
};
